import MainContentContainer from "./MainContentContainer";

export default MainContentContainer;
